import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { labelStyle } from './vinExtractionStyles';

const TICK_MS = 30 * 1000;

const useNow = () => {
    const [now, setNow] = useState(() => dayjs());

    useEffect(() => {
        const id = setInterval(() => setNow(dayjs()), TICK_MS);
        return () => clearInterval(id);
    }, []);

    return now;
};

const updatedAgoText = (t, minutes) => {
    if (minutes < 1) return t('updated.justNow');
    if (minutes < 60) return t('updated.minutesAgo', { count: minutes });
    return t('updated.hoursAgo', { count: Math.floor(minutes / 60) });
};

/** "Updated N min ago" since the last successful fetch, ticking while the page is open. */
const UpdatedAgo = ({ lastFetchedAt }) => {
    const { t } = useTranslation('vinExtraction');
    const now = useNow();

    if (!lastFetchedAt) return <span style={labelStyle}>{t('updated.never')}</span>;
    const text = updatedAgoText(t, Math.max(0, now.diff(lastFetchedAt, 'minute')));

    return (
        <span style={labelStyle} title={lastFetchedAt.format('D MMM YYYY HH:mm:ss')}>
            {text}
        </span>
    );
};

export default UpdatedAgo;
